module.exports = __webpack_public_path__ + "static/img/yj-banner.5b4402b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yj-banner.png
// module id = siDR
// module chunks = 1